import React from 'react';
import './scss/App.scss';
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import { Suspense } from 'react';
// import { Physics } from '@react-three/cannon';

// import Plane from './Plane/Plane';
// import Box from './Box/Box';

// import Tracer from './Tracer/Scene';
// import Flower from './Flower/Flower2';
import Flower from './Flower/Flower4';

// Значения по уmолчанию x = 0, y = 0, z = 5 ?

let texts = [
  'Коли пролітала комета Галлея – мені здалося, що вона озирнулася на нас, і зареготала. © Ліна Костенко',
  'Ми досі ще рятуємо дистрофію тіл, а за прогресуючу дистрофію душ — нам байдуже. © Василь Стус',
  'На світі той наймудріший, хто найдужче любить життя. © Василь Симоненко',
  'З видимого пізнавай невидиме. © Григорій Сковорода',
  'Кохайтеся ж, любітеся, як серденько знає. © Тарас Шевченко',
];

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      showText: false,
      textTransform: 'translateY(-2000px)',
      text: texts[4],
    };
  }
  clickHandler = () => {
    if (!this.state.showText) {
      this.setState({ textTransform: 'translateY(0px)', showText: true, text: texts[Math.floor(Math.random() * texts.length)] });
    } else {
      this.setState({ textTransform: 'translateY(-2000px)', showText: false });
    }
  }
  render() {
    return (
      <main className='main__page'>
        <div className='main__button' onClick={this.clickHandler}>{!this.state.showText ? '?' : <div className='main__button_active'></div>}</div>
        <div className='main__text_wrapper' style={{ transform: this.state.textTransform }}>
          <div className='main__text'>
            {this.state.text}
          </div>
        </div>
        <Canvas camera={{ position: [-9, 9, -8], zoom: 1 }}>
          <OrbitControls />
          {/* <Physics> */}
          <color attach='background' args={['black']} />
          {/* <hemisphereLight intensity={0.35} /> */}
          <spotLight
            position={[-11, 5, 10]}
            angle={0.3}
            penumbra={1}
            intensity={2}
            castShadow
          />
          {/* <spotLight
            position={[-11, -50, 20]}
            angle={0.3}
            penumbra={1}
            intensity={10}
            castShadow
          /> */}
          {/* <Plane /> */}
          {/* <Box /> */}
          {/* <Box position={[0, 10, 0]} /> */}
          {/* </Physics> */}
          {/* <Box position={[-4, 0, 0]} />
    <Box position={[0, 0, 0]} rotation={[Math.PI / 4, Math.PI / 4, 0]} />
    <Box position={[4, 0, 0]} /> */}
          <Suspense fallback={null}>
            {/* <Tracer /> */}
            <Flower />
          </Suspense>
        </Canvas>
      </main>
    )
  }
}

export default App;
